import { sharedParamsConfig } from '@oneToOne/shared/params'
import type { liveHelperActions } from '@oneToOne/shared/utils/liveHelperActions'

import type { ParamsType } from '@core/params'
import { mergeConfigs } from '@core/params'

export type LiveHelperAction = keyof typeof liveHelperActions

const actions: LiveHelperAction[] = ['startCall', 'startChat', 'showWidget']

const agentStatusConfig = {
  stringParams: ['chat_channel_id'],
  boolParams: [
    'bypass_sa_availability',
    'dismiss_after_conversation_ended',
    'bypass_qualify_visitors',
    'bypass_widget_availability_hidden',
  ],
  numberParams: [],
  enumParams: {
    action: actions,
  },
  // Unable to use `satisfies`. Need storybook 7+ to not break chromatic CI
  // } as const satisfies ParamsConfig
} as const

export const configs = mergeConfigs(sharedParamsConfig, agentStatusConfig)

export type AgentStatusParams = ParamsType<typeof configs>
